import React from "react";
import changeAvatarIcon from "@assets/images/icons/change-avatar.svg";

export const ProfileAvatar = ({ 
  localAvatar, 
  uploading, 
  handleUploadClick, 
  fileInputRef, 
  handleFileChange 
}) => {
  const defaultAvatar = (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60" cy="60" r="60" fill="#3A3A3A" />
      <path
        d="M60.018 51.5C54.33 51.5 50.518 47.686 50.518 42C50.518 36.314 54.33 32.5 60.018 32.5C65.706 32.5 69.518 36.314 69.518 42C69.518 47.686 65.706 51.5 60.018 51.5ZM60.018 37.5C56.484 37.5 53.518 39.466 53.518 42C53.518 44.034 56.484 48.5 60.018 48.5C63.552 48.5 66.518 44.034 66.518 42C66.518 39.466 63.55 37.5 60.018 37.5ZM65.994 73.5H54.006C49.166 73.5 46.5 70.85 46.5 66.038C46.5 60.716 49.512 54.5 56 54.5H64C70.488 54.5 73.5 60.714 73.5 66.038C73.5 70.85 70.834 73.5 65.994 73.5ZM56 57.5C50.614 57.5 47.5 64.034 47.5 66.038C47.5 69.166 48.848 70.5 54.006 70.5H65.994C71.152 70.5 72.5 69.166 72.5 66.038C72.5 64.036 69.386 57.5 64 57.5H56Z"
        fill="white"
      />
    </svg>
  );

  return (
    <div className="profile-tab__avatar-wrapper">
      {localAvatar ? <img src={localAvatar} alt="User Avatar" /> : defaultAvatar}
      <button
        className="profile-tab__avatar-change"
        onClick={handleUploadClick}
        disabled={uploading}
        type="button"
      >
        <img src={changeAvatarIcon} alt="change avatar" />
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
};